// extracted by mini-css-extract-plugin
export default {"container":"FullscreenContentViewer_container__UUaaG"};